function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
        if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) executeCallback = true
    } else if (event.type.includes('shopify:block') && event.target === domElement) { 
        executeCallback = true 
    }
    if (executeCallback) callback(event)
}

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => { const roundedVh = Math.round(window.innerHeight * 0.01); document.body.style.setProperty('--vh', `${roundedVh}px`) };
window.addEventListener('resize', getSetVh);

// Browser check
function getNavigator() {
    const isiOS = navigator.userAgent.match(/(iPhone|iPad|iPod)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

    if (isiOS) document.documentElement.classList.add('ios');
    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
    }


    function initializeDetailsControls() {
        // Handle dropdown menu
        const detailsElementsLv1 = document.querySelectorAll('details.lv1');
        const detailsElementsClosex = [...document.querySelectorAll('details.closex')];
    
        function closeOtherDetails(element) {
            const detailsOpened = document.querySelectorAll('details[open].lv1');
            for (const item of detailsOpened) {
                if (element !== item) {
                    item.removeAttribute('open');
                }
            }
        }

        function closeAllDetailsExcept(target) {
            detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
            a11yDetails();
        }
    
        function closeAllDetails() {
            detailsElementsClosex.forEach(f => f.removeAttribute('open'));
            a11yDetails();
        }
    
        // Dropdown menu
        detailsElementsLv1.forEach(item => {
            item.addEventListener('click', function() {
                closeOtherDetails(this);
            });
        });
    
        // Close details when clicked outside
        document.addEventListener('click', function(e) {
            if (!detailsElementsClosex.some(f => f.contains(e.target))) {
                closeAllDetails();
            } else {
                closeAllDetailsExcept(e.target);
            }
        });
    
        // Close details with esc key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAllDetails();
            }
        });
    
        // Initial accessibility settings
        a11yDetails();
    }

    function a11yDetails() {
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            });
        });
    }
    

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// Debug
if (window.location.href.indexOf("debug") > -1) {
    var OpenThinking = OpenThinking || {}; OpenThinking.theme = { "name":"Bullet", "version":`${window.BOOMR.themeVersion}` };
    console.log(`${OpenThinking.theme.name} v${OpenThinking.theme.version}`);
}

// // Bullet marquee
// if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
//     constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

//     duration(entries) {
//         const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
//         const contentWidth = entries[0].contentRect.width;
      
//         // Calculate the slowFactor based on content width
//         let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

//         // Calculate the scrolling speed with the adjusted slowFactor
//         const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

//         this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
//     }
// });

// Bullet marquee (Safari/iOS 대응)
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    connectedCallback() {
        this._update = this.duration.bind(this);
        this._onVisible = () => { if (document.visibilityState === 'visible') this.restart(); };
        this._onPageShow = (e) => { if (e.persisted) this.restart(); };

        // 컨테이너 + 첫 문장 크기 변화를 모두 감시
        if (window.ResizeObserver) {
            this._ro = new ResizeObserver(this._update);
            this._ro.observe(this);
            const first = this.querySelector('.projectile');
            if (first) this._ro.observe(first);
        }

        // 레이아웃·폰트·이미지 로드 후 재계산 (Safari에서 첫 계산이 0으로 나오는 문제)
        window.addEventListener('load', this._update);
        window.addEventListener('resize', this._update);
        window.addEventListener('orientationchange', this._update);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._update);
        this.querySelectorAll('img').forEach(img => {
            if (!img.complete) img.addEventListener('load', this._update, { once: true });
        });

        // 탭 복귀·뒤로가기 시 애니메이션 재시작
        document.addEventListener('visibilitychange', this._onVisible);
        window.addEventListener('pageshow', this._onPageShow);

        requestAnimationFrame(this._update);
    }

    disconnectedCallback() {
        if (this._ro) this._ro.disconnect();
        window.removeEventListener('load', this._update);
        window.removeEventListener('resize', this._update);
        window.removeEventListener('orientationchange', this._update);
        document.removeEventListener('visibilitychange', this._onVisible);
        window.removeEventListener('pageshow', this._onPageShow);
    }

    duration() {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5, 10);
        const cs = getComputedStyle(this);
        const contentWidth = this.getBoundingClientRect().width
            - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
        const first = this.querySelector('.projectile') || this.querySelector('span');
        const itemWidth = first ? first.getBoundingClientRect().width : 0;

        // 아직 레이아웃 전이면 건너뛰고 다음 이벤트에서 다시 계산
        if (!contentWidth || !itemWidth) return;

        const slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);
        const scrollingDuration = scrollingSpeed * slowFactor * itemWidth / contentWidth;

        if (isFinite(scrollingDuration) && scrollingDuration > 0) {
            this.style.setProperty('--bullet-speed', `${scrollingDuration.toFixed(3)}s`);
        }
    }

    restart() {
        const els = [this, ...this.querySelectorAll('.projectile')];
        els.forEach(el => { el.style.webkitAnimation = 'none'; el.style.animation = 'none'; });
        void this.offsetWidth; // 리플로우 강제
        els.forEach(el => { el.style.webkitAnimation = ''; el.style.animation = ''; });
        this.duration();
    }
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    getNavigator(); // get the browser + OS
    toggleMenu(); // toggle Menu
    initializeDetailsControls(); // call details 
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })